import BottomRegisterBar from './BottomRegisterBar';

export default BottomRegisterBar;
